<template>
  <modal name="ModalSubmitDrafts" class="modal-submit-drafts" :width="'30%'" :height="'auto'" :scrollable="true" @before-open="beforeOpen">
    <div class="main-content">
      <p class="text-question">Are you sure you want to submit your drafts?</p>
      <p class="text-description">You are submitting <b>{{currentEvent.eventName}}.</b>  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted.</p>
      <div class="btn-container">
        <b-button class="btn-cancel" @click="onCancel">
          Cancel
        </b-button>
        <b-button class="btn-submit" @click="onSubmit">
          <b-spinner v-if="loadingSubmit"></b-spinner>
          Submit
        </b-button>
      </div>
    </div>
  </modal>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'ModalSubmitDrafts',
  props: {
    currentEvent: { type: Object }
  },
  data () {
    return {
      loadingSubmit: false
    }
  },
  methods: {
    onCancel () {
      this.$modal.hide('ModalSubmitDrafts');
    },
    onSubmit () {
      this.loadingSubmit = true;
      this.updateEvent(Object.assign(this.currentEvent, {status: 'APPROVED'})).then(() => {}).finally(() => {
        this.$modal.hide('DraftEventModal');
        this.loadingSubmit = false;
      });
    },
    ...mapActions({
      getEventList: 'ACTION_GET_EVENT_LIST',
      updateEvent: 'ACTION_UPDATE_EVENT'
    })
  }
}
</script>


// WEBPACK FOOTER //
// ModalSubmitDrafts.vue?57a65e6e